import { render, staticRenderFns } from "./certificationInfo.vue?vue&type=template&id=7213c332&scoped=true"
import script from "./certificationInfo.vue?vue&type=script&lang=js"
export * from "./certificationInfo.vue?vue&type=script&lang=js"
import style0 from "./certificationInfo.vue?vue&type=style&index=0&id=7213c332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7213c332",
  null
  
)

export default component.exports